import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { AppStrings } from "../../utils/constants/AppStrings";
import { getApiErrorMessage } from "../../utils/ErrorUtils";
import { bonusAdminEnvelope } from "./bonusAdminBody";
import { getSeriesQueryKey } from "./useGetSeries";
import { getSeriesRunsQueryKey } from "./useListSeriesRuns";
import { LIST_SERIES_QUERY_KEY } from "./useListSeries";

type StoredToken = { AccessToken?: string };

async function deleteSeries(seriesId: string): Promise<string | undefined> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.DELETE_DYNAMIC_BONUS_SERIES.replace(
    "{series_id}",
    seriesId,
  );
  const response = await instance.delete(url);
  return bonusAdminEnvelope(response).message;
}

export const useDeleteSeries = (seriesId: string) => {
  const queryClient = useQueryClient();

  return useMutation<string | undefined, Error, void>({
    mutationFn: () => deleteSeries(seriesId),
    onSuccess: (backendMessage) => {
      queryClient.invalidateQueries({ queryKey: LIST_SERIES_QUERY_KEY });
      queryClient.removeQueries({ queryKey: getSeriesQueryKey(seriesId) });
      queryClient.removeQueries({ queryKey: getSeriesRunsQueryKey(seriesId) });
      message.success(
        backendMessage || AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED,
      );
    },
    onError: (error) => {
      message.error(
        getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED),
      );
    },
  });
};
